import {useEffect, useState} from 'react'
import {Container, Text1, View} from "../../../../styles/business-components";
import * as S from './styles'
import {Slider, SliderItem} from "./Slider";

import FileManagerImage from '../../../../assets/images/business/b_m_cnt7_file_image.png'
import AdministrationImage from '../../../../assets/images/business/b_m_cnt7_adm_image.png'
import ConfImage from '../../../../assets/images/business/b_m_cnt7_conf_image.png'
import PcVersionImage from '../../../../assets/images/business/b_m_cnt7_pc_image.png'
import TelephonyImage from '../../../../assets/images/business/b_m_cnt7_phone_image.png'

type ItemType = {
    menu: string
    title: string
    text: string
    image: string
}

const items : ItemType[] = [
    {
        menu: 'Менеджер файлов',
        title: 'Менеджер файлов',
        text: 'До 100 участников в видеоконференции единовременно',
        image: FileManagerImage
    },
    {
        menu: 'Админнистрирование',
        title: 'Админнистрирование',
        text: 'До 100 участников в видеоконференции единовременно',
        image: AdministrationImage
    },
    {
        menu: 'Видеоконференции',
        title: 'Видеоконференции',
        text: 'До 100 участников в видеоконференции единовременно',
        image: ConfImage
    },
    {
        menu: 'Версия для ПК',
        title: 'Версия для ПК',
        text: 'До 100 участников в видеоконференции единовременно',
        image: PcVersionImage
    },
    {
        menu: 'Телефония',
        title: 'Телефония',
        text: 'До 100 участников в видеоконференции единовременно',
        image: TelephonyImage
    }
]

export const Content7 = () => {
    const [activeIndex, setActive] = useState(0);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setActive(activeIndex + 1 >= items.length ? 0 : activeIndex + 1)
        }, 5000);
        return () => clearTimeout(timeout);
    }, [activeIndex]);

    const nextItem = () => setActive(activeIndex + 1 >= items.length ? 0 : activeIndex + 1)

    return (
        <Container>
            <S.Title>
                Teleguard business предлагает больше чем обычные мессенджеры
            </S.Title>
            <S.Text>
                TeleGuard Business - суверенитет данных в ваших собственных руках! – Ваши данные в ваших руках!
                Никто, кроме вас самих, не владеет вашими данными, включая все административные права.
                Мы не имеем возможности получить доступ к вашим данным.
            </S.Text>
            <S.Text>
                Сочетание функциональности и инноваций делает TeleGuard уникальным. Превосходное качество голосовой и видеоконференцсвязи.
            </S.Text>

            <S.SliderBox>
                <View>
                    <S.SliderMenu>
                        {
                            items.map((item, idx) =>
                                <S.SliderMenuItem key={idx} active={idx === activeIndex} onClick={() => setActive(idx)}>{item.menu}</S.SliderMenuItem>
                            )
                        }
                    </S.SliderMenu>
                </View>
                <Slider activeIndex={activeIndex}>
                    {
                        items.map((item, idx) =>
                            <SliderItem
                                key={idx}
                                onClick={nextItem}
                                title={item.title}
                                text={item.text}
                                image={item.image}
                            />
                        )
                    }
                </Slider>
            </S.SliderBox>
        </Container>
    )
}